import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { Observable, of } from 'rxjs';
import { SearchItem } from 'src/app/models/searchItem';
import { Shortcuts } from 'src/app/models/Shortcuts';
import { EndpointsService } from 'src/app/services/endpoints.service';
import { SearchService } from 'src/app/services/search.service';
import {environment} from "../../../../environments/environment";
import { ModalControlService } from 'src/app/services/modal-control.service';

@Injectable({
  providedIn: 'root'
})
export class ShortcutsModalControlService {

  shortcuts : SearchItem[] = [];

  constructor(private http: HttpClient,
    private endpointService : EndpointsService,
    private searchService : SearchService,
    private modalService : ModalControlService,) {
   }

  showMesssageModal(title:string, body : string){
    // const bsModalRef : BsModalRef = this.modalService.show(ShortcutsComponent);
    // bsModalRef.content.title = title;
    // bsModalRef.content.body = body;
  }

  getAllShorcuts() : Observable<Shortcuts[]> {
    return this.http.get<Shortcuts[]>(
      `${environment.navaids}/shortcuts`,
      this.endpointService.httpOptions
      )
  }

  addShortcut(shorcut : Shortcuts) : void {
    this.http.post(
      `${environment.navaids}/shortcuts`,
      shorcut,
      this.endpointService.httpOptions
    ).subscribe(
      (data) => console.log(data),
      (error) => console.log(error)
    );
  }

  insertShortcutsBulk(shorcuts : Shortcuts[]) : void {
    this.http.post(
      `${environment.navaids}/shortcuts/bulk`,
      shorcuts,
      this.endpointService.httpOptions
    ).subscribe({
      next: (shortcutsReturned: Shortcuts[]) => {
        this.shortcuts.sort(function(a, b){
          if(a.name < b.name) { return -1; }
          if(a.name > b.name) { return 1; }
          return 0;
        })
        shortcutsReturned.sort(function(a, b){
          if(a.sAction < b.sAction) { return -1; }
          if(a.sAction > b.sAction) { return 1; }
          return 0;
        })
        for (let i = 0; i<this.shortcuts.length; i++){
          this.shortcuts[i].shortcutId = shortcutsReturned[i].id;
        }
      },
      error: (error) => {
        console.log(error);
        this.modalService.showMesssageModal("Shortcuts", "There was an error saving shortcuts.")
      }
    })
    //   (data) => console.log(data),
    //   (error) => console.log(error)
    // );
  }

  deleteShortcut(id: string): Observable<boolean> {
    this.http.delete<boolean>(
      `${environment.navaids}/shortcuts` + '/' + id,
        this.endpointService.httpOptions
      )
      .subscribe(
        () => {
          return true;
        },
        () => {
          return false;
        }
      );
    return of(false);
  }

  updateShortcutsList() : void {
    this.shortcuts = [];
    this.getAllShorcuts().subscribe( results =>{
      results.forEach( shortcut => {
        let shortcutItem : Shortcuts = shortcut;
        let searchItem = this.searchService.getItemByShortcut(shortcutItem);
        this.shortcuts.push(searchItem);
      })
    });
  }

}
